import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import * as store from "../../store/flyer-detail-page-form-page.store";
import { SpinnerLoader } from "../../../../../../../../../../components/loaders";
import { FlyerDetailPageFormPageView } from "../flyer-detail-page-form-page-view/flyer-detail-page-form-page-view.component";
import * as flyerStore from "../../../../../../../../store/flyer.store";

export const FlyerDetailPageFormPage = () => {
  const page = useSelector(store.getPage);
  const isLoading = useSelector(store.isLoading);
  const permissions = useSelector(flyerStore.getPermissions);

  useEffect(() => {
    if (page === null) {
      store.fetchPage();
    }
  });

  return (
    <>
      <SpinnerLoader showIf={isLoading} />
      <FlyerDetailPageFormPageView
        showIf={Boolean(page) && Boolean(permissions) && !isLoading}
        page={page!}
        permissions={permissions!}
        onSave={store.savePage}
      />
    </>
  );
};
